import loadable from '@loadable/component';

export const CmsTileGridBlockLoadable = loadable(
  () => import('./CmsTileGridBlock'),
  { resolveComponent: (module) => module.CmsTileGridBlock },
);
